export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/school/updatePhotoGalleryYear',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['photogallery'],
    })
